<template>
    <div>
        <div v-if="isShowSlider" class="slider-menu-masking" @click="changeSlider">
            <div class="slider-menu" :style="{ height: innerHeight + 'px' }" @click.stop="func1()">
                <div class="activity-title">{{ GLOBAL.lanLocal['activity'] }}</div>
                <div class="activity-list">
                    <div class="activity-item" v-for="(item, index) in activityList" :key="index + 1"
                        @click="activityDetail(item.id)">
                        <img :src="item.img" />
                    </div>
                </div>
                <!-- <div class="download">
                    <img class="icon" :src="require('../../assets/icon/download.png')" />
                    <div>{{ GLOBAL.lanLocal['appdownload'] }}</div>
                </div> -->
                <div class="lan" @click="changeLan">
                    <template v-for="(item, index) in lanData">
                        <img v-if="lanCode == item.code" class="icon" :src="item.img" />
                        <div v-if="lanCode == item.code" class="lan-desc">
                            <div>{{ item.title }}</div>
                            <img class="down" :src="require('../../assets/icon/down.png')" />
                        </div>
                    </template>
                    <div class="lan-box" v-if="isShowLan">
                        <div class="lan-item" v-for="(item, index) in lanData" @click="changeLanCode(item.code)">
                            <img class="icon" :src="item.img" />
                            <div>{{ item.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="loading-masking" v-if="loading">
            <div class="loading-page">
                <vue-simple-spinner size="large" line-fg-color="#f69b09"></vue-simple-spinner>
            </div>
        </div>
        <NavHeader v-if="tabIndex != 5 && tabIndex != 51 && tabIndex != 7" @changeSlider="changeSlider"
            @setLan="changeLanCode" @toDeposit="toDeposit" @toMe="showPage(4)" :accountid="GLOBAL.userInfo.accountid"
            :amount="amount" :lanData="lanData"></NavHeader>
        <HomePage v-if="tabIndex == 1" @toGame="toGame" @reload="reload" @signin="signin" @reg="reg"
            @toForgot="showPage(7)"></HomePage>
        <ActivityPage v-if="tabIndex == 2" @detail="activityDetail"></ActivityPage>
        <ActivityDetailPage v-if="tabIndex == 21" :id="id" @close="closeModal"></ActivityDetailPage>
        <EmailPage v-if="tabIndex == 3" @detail="emailDetail"></EmailPage>
        <EmailDetailPage v-if="tabIndex == 31" :id="id" @close="closeModal" @in="getEmailCount(false)"></EmailDetailPage>
        <MyPage v-if="tabIndex == 4" @logout="logout" :amount="amount"></MyPage>
        <LoginPage v-if="tabIndex == 5" @reload="reload" @reg="reg" @toForgot="showPage(7)"></LoginPage>
        <RegisterPage v-if="tabIndex == 51" @signin="signin" @success="showPage(1)"></RegisterPage>
        <DepositPage v-if="tabIndex == 6" @close="closeModal" @toBind="toBind" @toService="showPage(8)" @reload="reload">
        </DepositPage>
        <ForgotPage v-if="tabIndex == 7" @close="closeModal" @signin="signin"></ForgotPage>
        <ServicePage v-if="tabIndex == 8" @close="closeModal"></ServicePage>
        <BindPage v-if="tabIndex == 9" @close="closeModal"></BindPage>
        <Tabbar :accountid="GLOBAL.userInfo.accountid" :index="tabIndex" :emailCount="emailCount" @change="showPage">
        </Tabbar>
        <iframe v-show="url" :src="url" class="gameFrame" scrolling="no"
            sandbox="allow-scripts allow-top-navigation allow-same-origin"></iframe>
    </div>
</template>
<script>
import loadFile from "../../api/loadFile.js"
import md5 from 'js-md5';
import HomePage from '../home/home.vue'
import ActivityPage from '../activity/activity.vue'
import ActivityDetailPage from '../activity/activityDetail.vue'
import LoginPage from '../login/login.vue'
import RegisterPage from '../register/register.vue'
import MyPage from '../my/my.vue'
import DepositPage from '../deposit/deposit.vue'
import EmailPage from '../email/email.vue'
import EmailDetailPage from '../email/emailDetail.vue'
import ForgotPage from '../forgot/forgot.vue'
import ServicePage from '../service/service.vue'
import BindPage from '../bind/bind.vue'
import NavHeader from '../navheader/navheader.vue'
import Tabbar from '../tabbar/tabbar.vue'
import AES from "../../common/AES.js"
import { doPost } from '../../api/api.js'
import { v4 as uuidv4 } from 'uuid'
export default {
    name: 'index',
    components: { NavHeader, HomePage, Tabbar, LoginPage, MyPage, ActivityPage, DepositPage, EmailPage, ActivityDetailPage, EmailDetailPage, RegisterPage, ForgotPage, ServicePage, BindPage },
    data() {
        return {
            id: 0,
            url: '',
            lanCode: '',
            lanData: [
                { 'code': 'en', 'img': require('../../assets/icon/en.png'), 'title': 'English' },
                { 'code': 'th', 'img': require('../../assets/icon/th.png'), 'title': 'ประเทศไทย' },
            ],
            tabIndex: 1,
            isShowSlider: false,
            activityList: [],
            loading: false,
            isShowLan: false,
            amount: '0.00',
            loginType: 1,
            innerHeight: 0,
            emailTimer: null,
            emailCount: 0
        }
    },
    created() {
        this.innerHeight = window.innerHeight - 130
        let lanCode = localStorage.getItem(md5('__lanCode__'))
        if (lanCode) {
            this.GLOBAL.lanCode = lanCode
        }
        this.lanCode = this.GLOBAL.lanCode
        const lanLocal = loadFile("static/json/" + this.GLOBAL.lanCode + ".json", false);
        this.GLOBAL.lanLocal = lanLocal


        const json = loadFile("static/nonce", true);
        if (json != null) {
            this.GLOBAL.apiAesKey = json['api_aes_key'];
            this.GLOBAL.apiUrl = json['ip'];
        }
        let deviceid = localStorage.getItem(md5('__deviceid__'))
        if (deviceid) {
            deviceid = AES.decrypt(deviceid, this.GLOBAL.apiAesKey)
        } else {
            deviceid = uuidv4()
            localStorage.setItem(md5('__deviceid__'), AES.encrypt(deviceid, this.GLOBAL.apiAesKey))
        }
        this.GLOBAL.deviceid = deviceid
        doPost({
            n: 'AppEx',
            a: 'get_lan',
        }).then((res) => {
            if (res.code === 0) {
                this.GLOBAL.lanArr = JSON.parse(res.data[this.GLOBAL.lanCode])
            }
        })
        this.reload()
    },
    computed: {

    },
    mounted() {
        window.addEventListener('message', event => {
            let data = event.data
            if (data.cmd === 'jump') {
                this.reload()
            }
        })
    },
    methods: {
        toGame(url) {
            this.url = url
        },
        reg() {
            this.showPage(51)
        },
        signin() {
            this.showPage(5)
        },
        logout() {
            this.GLOBAL.userInfo.accountid = 0
            this.GLOBAL.userInfo.name = ''
            this.GLOBAL.userInfo.passcode = ''
            localStorage.removeItem(md5('__name__'))
            localStorage.removeItem(md5('__pwd_'))
            clearInterval(this.emailTimer)
            this.showPage(1)
        },
        activityDetail(id) {
            this.id = Number(id)
            localStorage.setItem("back", this.tabIndex)
            if (this.isShowSlider) {
                this.changeSlider()
            }
            this.showPage(21)
        },
        emailDetail(id) {
            this.id = Number(id)
            localStorage.setItem("back", this.tabIndex)
            this.showPage(31)
        },
        func1() { },
        changeLan() {
            this.isShowLan = !this.isShowLan
        },
        getEmailCount() {
            let that = this
            let et = localStorage.getItem(md5('___emailtime____'))
            let nowTime = parseInt(new Date().getTime() / 1000)
            if(et && nowTime - et <= 10)
            {
                return 
            }

            clearInterval(that.emailTimer)
            doPost({
                n: 'AppEx',
                a: 'get_hall_count',
                accountid: that.GLOBAL.userInfo.accountid,
            }).then((res) => {
                localStorage.setItem(md5('___emailtime____'), parseInt(new Date().getTime() / 1000))
                that.emailCount = res.data.mail_count
                that.emailTimer = setInterval(() => {
                    that.getEmailCount()
                }, 15000)
            })
        },
        reload() {
            this.loading = true
            this.url = ""
            let that = this
            let name = localStorage.getItem(md5('__name__'))
            let pwd = localStorage.getItem(md5('__pwd_'))
            if (name) {
                name = AES.decrypt(name, this.GLOBAL.apiAesKey)
                if (name) {
                    this.GLOBAL.userInfo.name = name
                }
            }
            if (pwd) {
                pwd = AES.decrypt(pwd, this.GLOBAL.apiAesKey)
                if (pwd) {
                    this.GLOBAL.userInfo.pwd = pwd
                }
            }
            if (name && pwd) {
                doPost({
                    n: 'AppGame',
                    a: 'do_login',
                    mobile: name,
                    password: pwd
                }).then((res) => {
                    if (res.code === 0) {
                        localStorage.setItem(md5('__name__'), AES.encrypt(name, that.GLOBAL.apiAesKey))
                        localStorage.setItem(md5('__pwd_'), AES.encrypt(pwd, that.GLOBAL.apiAesKey))

                        that.GLOBAL.userInfo.accountid = res.data.accountid
                        that.GLOBAL.userInfo.nickname = res.data.nickname
                        that.GLOBAL.userInfo.name = name
                        that.GLOBAL.userInfo.passcode = pwd
                        that.amount = res.data.amount

                        that.getEmailCount(true)
                        that.tabIndex = 1
                    } else {
                        const data = decodeApiLan(res, this.GLOBAL.lanArr);
                        this.$toast.error(data.message, {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: false,
                            icon: true,
                            rtl: false
                        });
                        this.logout()
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }

        },
        showPage(index) {
            if (this.tabIndex != index) {
                this.tabIndex = index
                window.scrollTo(0,0)
            }
        },
        changeSlider() {
            if (this.isShowSlider) {
                this.isShowSlider = !this.isShowSlider
                this.isShowLan = false
            } else {
                doPost({
                    n: 'AppEx',
                    a: 'get_activity_list',
                    accountid: this.GLOBAL.userInfo.accountid,
                }).then((res) => {
                    this.activityList = res.data.list
                    this.isShowSlider = !this.isShowSlider

                })
            }
        },
        toDeposit() {
            if (!this.GLOBAL.userInfo.accountid || this.GLOBAL.userInfo.accountid == 0) {
                this.$toast.error(this.GLOBAL.lanLocal['nologin'], {
                    position: "top-center",
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: false,
                    icon: true,
                    rtl: false
                });
                return
            }
            localStorage.setItem("back", this.tabIndex)
            this.showPage(6)
        },
        toBind() {
            localStorage.setItem("back", this.tabIndex)
            this.showPage(9)
        },
        closeModal() {
            let back = localStorage.getItem("back")
            if (back) {
                this.showPage(Number(back))
                localStorage.removeItem("back")
            } else {
                this.showPage(1)
            }
            this.id = 0
        },
        changeLanCode(lanCode) {
            if (lanCode == this.lanCode) {
                this.showLan = false
                return
            }
            this.loading = true
            this.lanCode = lanCode
            localStorage.setItem(md5('__lanCode__'), this.lanCode)
            setTimeout(() => {
                window.location.reload()
            }, 100)
        },
    }
}
</script>

<style lang="less" scoped>
.slider-menu-masking {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 998;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.slider-menu {
    position: absolute;
    top: 60px;
    left: 0;
    z-index: 999;
    background-color: #000;
    height: -moz-calc(100vh - 130px);
    height: -webkit-calc(100vh - 130px);
    height: calc(100vh - 130px);
    width: 240px;
    overflow-y: scroll;
    padding: 22px 18px;
    text-align: left;
    box-sizing: border-box;

    .activity-title {
        color: rgb(233, 222, 124);
        font-size: 16px;
    }

    .activity-list {
        margin: 10px 0 30px;

        .activity-item {
            margin-bottom: 6px;

            img {
                width: 100%;
                height: auto;
                border-radius: 6px;
            }
        }
    }

    .download,
    .lan {
        background-color: rgb(39, 44, 50);
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-radius: 6px;
        position: relative;
        padding: 0 20px;
        box-sizing: border-box;

        .icon {
            height: 30px;
            width: 30px;
            margin-right: 8px;
        }

        div {
            color: rgb(144, 151, 161);
            font-size: 16px;
        }

        .down {
            width: 21px;
            height: 12px;
        }
    }

    .lan {
        margin-top: 10px;
        position: relative;

        .lan-desc {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex: 1;
        }

        .lan-box {
            position: absolute;
            left: 0;
            top: 52px;
            width: 100%;
            background-color: rgb(39, 44, 50);
            border-radius: 6px;

            .lan-item {
                width: 100%;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                position: relative;
                padding: 0 20px;
                box-sizing: border-box;
                border-bottom: 1px solid rgb(44, 50, 57);

                .icon {
                    height: 30px;
                    width: 30px;
                    margin-right: 8px;
                }

                div {
                    color: rgb(144, 151, 161);
                    font-size: 16px;
                }
            }
        }

    }
}

.gameFrame {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    border: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/index/index.vue